import dayjs from 'dayjs'
export default function formatDateTime(input) {
  var date = dayjs(input)
  if (date.isValid()) {
    return date.format('MM/DD/YYYY hh:mm A')
  } else {
    return ''
  }
}
